import { Component } from '@angular/core';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    standalone: false
})
export class NotificationComponent  {

  public openNotification: boolean = false;

  constructor() { }

  

  toggleNotificationMobile() {
    this.openNotification = !this.openNotification;
  }

}
